import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { CommunicationsService } from 'src/app/Shared/Commnunication/communications.service';
import { CommonService } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { UsersService } from 'src/app/Shared/Users/users.service';

declare var $: any;

@Component({
  selector: 'app-service-provider-list-view',
  templateUrl: './service-provider-list-view.component.html',
  styleUrls: ['./service-provider-list-view.component.css']
})
export class ServiceProviderListViewComponent implements OnInit {

  @Input() PortalType: string = 'Mobile';
  @ViewChild('usersListDiv', { static: false }) usersListDiv: ElementRef;
  @ViewChild('partnerVideo', { static: true }) partnerVideo: ElementRef;
  isLoader: boolean = false;
  userTypeID: number;
  authData: any;
  userProfileInfo: any;
  CategoryList: any[] = [];
  SubCategoryList: any[] = [];
  selectedCategory: string = '';
  CategoryID: number = 0;
  LoggedUserId: number = 0;
  PartnersList: any[] = [];

  currentView: string = 'main';
  videoUrl: string;
  selectedCategoryType: string = 'Service'; // Default value
  filteredCategoryList: any[] = [];

  categoryIcons = {
    'Construction Services': 'fas fa-tools',
    'Home Design and Décor': 'fas fa-paint-brush',
    'Interior Furnishings': 'fas fa-couch',
    'Landscaping and Outdoor': 'fas fa-tree',
    'Legal & Financial': 'fas fa-balance-scale',
    'Maintenance and Repairs': 'fas fa-hammer',
    'Moving and Storage': 'fas fa-truck',
    'Real Estate Services': 'fas fa-sign',
    'Utilities and Security': 'fas fa-shield-alt'
  };

  searchText: string = '';
  filteredPartnersList: any[] = [];
  allPartnersList: any[] = [];
  constructor(private serCommonService: CommonService, private myprofileUsersService: UsersService,
    private viewCommonService: CommonService, private viewPostsService: PropertyPostsService,
    private searchCommunicationsService: CommunicationsService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.authData = localStorage.getItem('authData') == undefined ? '' : JSON.parse(localStorage.getItem('authData'));
    this.userProfileInfo = localStorage.getItem('authProfileData') == undefined ? '' : JSON.parse(localStorage.getItem('authProfileData'));
    this.userTypeID = this.authData.UserType;
    this.LoggedUserId = this.authData.UserID;
    this.LoadBusinessCategoryList();
  }

  ngAfterViewInit() {
    // Initialize the modal after the view initializes
    ($('#videoModal') as any).modal({ show: false });
  }

  searchCategories() {

    const keyword = this.searchText?.trim().toLowerCase();
    alert(keyword);
    // Prevent empty search
    if (!keyword) {
      this.serCommonService.CallToster('W', 'Please enter a keyword to search.');
      return;
    }

    // Ensure data is available
    if (!this.allPartnersList || this.allPartnersList.length === 0) {
      this.serCommonService.CallToster('W', 'No partner data available to search.');
      this.searchText = '';
      return;
    }

    // Filter based on keyword
    this.filteredPartnersList = this.allPartnersList.filter(user =>
      user?.Business_Category?.toLowerCase().includes(keyword)
    );

    // Update view
    this.currentView = 'partners';
    this.selectedCategory = null;
    this.CategoryID = null;
    this.SubCategoryList = [];

    // Reset input field
    this.searchText = '';
  }

  LoadBusinessCategoryList() {
    try {
      this.isLoader = true;
      this.viewPostsService.GetAllBusinessCategory().subscribe((res) => {
        this.isLoader = false;
        if (res.status === 1) {
          this.CategoryList = res.body.map(category => {
            return {
              ...category,
              icon: this.categoryIcons[category.ParentCategory] || 'fas fa-list-alt'
            };
          });
          this.filterCategories(); // Initial filter
        }
      }, err => {
        this.isLoader = false;
        // Handle errors
      });
    } catch (error) {
      this.isLoader = false;
      // Handle errors
    }
  }

  // Filter categories based on the selected category type
  onCategoryTypeChange(categoryType: string) {
    this.selectedCategoryType = categoryType;
    this.filterCategories();
  }

  // Function to filter categories locally
  filterCategories() {
    if (this.selectedCategoryType === 'Service') {
      this.filteredCategoryList = this.CategoryList.filter(category => category.CatType === 'Service'); // Adjust the filter as needed
    } else {
      this.filteredCategoryList = this.CategoryList.filter(category => category.CatType === 'Supplier'); // Adjust the filter as needed
    }
    this.cdr.detectChanges(); // Ensure change detection
  }

  LoadSubCategory(category: string) {
    this.selectedCategory = category;
    this.currentView = 'sub';
    try {
      this.isLoader = true;
      this.myprofileUsersService.GetAllBusinessCategory(0, category).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          this.SubCategoryList = res.body;
        }
        if (this.usersListDiv && this.usersListDiv.nativeElement && this.PortalType == 'Mobile') {
          this.usersListDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, err => {
        this.isLoader = false;
        this.SubCategoryList = [];
      });
    } catch (error) {
      this.isLoader = false;
      this.SubCategoryList = [];
    }
  }

  LoadBusinessPartnerList(categoryID: number) {
    this.CategoryID = categoryID;
    this.currentView = 'partners';
    try {
      this.isLoader = true;
      this.myprofileUsersService.GetBusinessPartners(this.CategoryID, this.LoggedUserId).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1 && res.body?.length > 0) {
          this.allPartnersList = res.body;
          this.PartnersList = [...this.allPartnersList];
          this.filteredPartnersList = [...this.allPartnersList];
        } else {
          this.PartnersList = [];
          this.filteredPartnersList = [];
          // DO NOT clear allPartnersList here
        }

      }, err => {
        this.isLoader = false;
        this.PartnersList = [];
        this.filteredPartnersList = [];
      });
    } catch (error) {
      this.isLoader = false;
      this.PartnersList = [];
      this.filteredPartnersList = [];
    }
  }


  goBack() {
    if (this.currentView === 'partners' && this.CategoryID) {
      // Going back from partners to sub
      this.currentView = 'sub';
    } else {
      // Going from sub to main
      this.currentView = 'main';
      this.selectedCategory = null;
      this.CategoryID = null;
    }
  }

  doContactAgent(cType: string, rType: any) {
    try {
      this.isLoader = true;
      let data = {
        UserID: this.authData.UserID,
        PartnerID: rType.PartnerID,
        Category: rType.Business_Category,
        Communication_Type: cType
      };

      this.searchCommunicationsService.AddUpdateServiceMessageInfo(JSON.stringify(data)).subscribe(res => {
        this.isLoader = false;
        if (res && res.status === 1) {
          if (res.body === 1) {
            //this.serCommonService.CallToster('S', 'Thank you, Your request has been submitted.');

            // Check if Communication_Type is 'Call' and trigger dialer
            if (cType === 'Call') {
              setTimeout(() => {
                // Replace 'XXXXXXXXXX' with the actual phone number
                document.location.href = "tel:" + rType.MobileNo + "";
              }, 500);
            }
            else {
              this.SendContactSMS(rType);
              this.serCommonService.CallToster('S', 'Your Request is Communicated successfully');
            }

          } else {
            // Handle other body values if needed
            this.serCommonService.CallToster('E', 'Already contacted or something went wrong.');
          }
        } else {
          // Handle other status codes or conditions
          this.serCommonService.CallToster('E', res.errorMessage || 'Already contacted  or something went wrong.');
        }
      }, err => {
        this.isLoader = false;
        this.serCommonService.CallToster('E', 'Something went wrong, Please try again later.');
      });
    } catch (error) {
      this.isLoader = false;
      this.serCommonService.CallToster('E', 'Unable to submit your details, Please try again later.');
    }
  }


  SendContactSMS(code: any) {
    try {

      let Text = "Congratulations! Important update from Buyrentsale.com on your property " + code.Property_Code + ". Log in for more information. - AINEXT IT";
      this.serCommonService.SendSMS(Text, code.MobileNo).subscribe(res => {
        //console.log(res);
      }, err => {
        //console.log(err);
      });
    } catch (error) {
      //console.log(error);
    }
  }

  showVideoModal(userId: number) {
    const currentTime = new Date().getTime();
    this.videoUrl = `https://api.buyrentsale.com/uploads/profilepic/${userId}.mp4?v=${currentTime}`;
    $('#videoModal').modal('show');
  }

  closeModal() {
    this.videoUrl = ''; // Clear the video URL
    ($('#videoModal') as any).modal('hide');
  }

}
